export default "__VITE_ASSET__B7dE1WB2AzHZ83oruoJ0pw__"